export function anchorLink() {
    $(".anchor-link").on("click", function (e) {
        e.preventDefault();
        let $target = $(this).attr("href");
        let $header = $(".header");
        let headerHeight = $header.outerHeight(true);
        let offset = $($target).offset().top - headerHeight;
        $("html, body").animate({scrollTop: offset}, 1000, function() {
            history.pushState(null, null, $target);
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/anchorLink.js